import { createStore } from "vuex";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
import axios from "axios";
export default createStore({
	state: {
		apiUrl: process.env.VITE_API_URL,
		authenticated: false,
		user: null,
		token: "",
		district: null,
		current_page: "",
		page: "",
		school_search: "",
		report_search: {
			district_id: "",
			school_id: "",
			user_id: "",
			stage_id: "",
			from_date_time: "",
			to_date_time: "",
			kg_strength: "",
			board: "",
			kg_strength_min: "",
			kg_strength_max: "",
		},
		reminder_search: {
			user_id: "",
			from_date_time: "",
			to_date_time: "",
		},
	},
	mutations: {
		setUser(state, user) {
			state.user = user;
		},
		setToken(state, token) {
			state.token = token;
		},
		setUrl(state, url) {
			state.apiUrl = url;
		},
		setPermissions(state, permissions) {
			state.permissions = permissions;
		},
		setDistrict(state, district) {
			state.district = district;
		},
		setPage(state, page) {
			state.page = page;
		},
		setCurrentPage(state, current_page) {
			state.current_page = current_page;
		},
		setSchoolSearch(state, school_search) {
			state.school_search = school_search;
		},
		setReportSearch(state, report_search) {
			state.report_search = report_search;
		},
		setReminderSearch(state, reminder_search) {
			state.reminder_search = reminder_search;
		},
	},

	getters: {
		user(state) {
			return state.user;
		},
		token(state) {
			return state.token;
		},
		apiUrl(state) {
			return state.apiUrl;
		},
		district(state) {
			return state.district;
		},
		permissions(state) {
			return state.permissions;
		},
		page(state) {
			return state.page;
		},
		current_page(state) {
			return state.current_page;
		},
		school_search(state) {
			return state.school_search;
		},
		report_search(state) {
			return state.report_search;
		},
		reminder_search(state) {
			return state.reminder_search;
		},
	},

	actions: {
		// async setPermissions(context, payload) {
		//     await context.commit('setPermissions', payload);
		// },
		async setUser(context, payload) {
			await context.commit("setUser", payload);
		},
		async setToken(context, payload) {
			await context.commit("setToken", payload);
		},
		async setDistrict(context, payload) {
			await context.commit("setDistrict", payload);
		},
		async setPage(context, payload) {
			await context.commit("setPage", payload);
		},
		async setCurrentPage(context, payload) {
			await context.commit("setCurrentPage", payload);
		},
		async setSchoolSearch(context, payload) {
			await context.commit("setSchoolSearch", payload);
		},
		async setReportSearch(context, payload) {
			await context.commit("setReportSearch", payload);
		},
		async setReminderSearch(context, payload) {
			await context.commit("setReminderSearch", payload);
		},

		async logout(context) {
			await context.commit("setUser", null);
			await context.commit("setToken", "");
		},

		auth(context, payload) {
			return new Promise((resolve, reject) => {
				axios
					.post(this.state.apiUrl + "api/" + payload.uri, payload.data)
					.then(function (response) {
						resolve(response);
					})
					.catch(function (error) {
						reject(error);
					});
			});
		},

		get(context, payload) {
			return new Promise((resolve, reject) => {
				axios
					.get(this.state.apiUrl + "api/" + payload.uri, payload.data)
					.then(function (response) {
						resolve(response);
					})
					.catch(function (error) {
						reject(error);
					});
			});
		},

		post(context, payload) {
			return new Promise((resolve, reject) => {
				axios
					.post(this.state.apiUrl + "api/" + payload.uri, payload.data, {
						headers: {
							Authorization: "Bearer" + " " + context.getters.token,
						},
					})
					.then(function (response) {
						resolve(response);
					})
					.catch(function (error) {
						reject(error);
						if (error?.response?.data?.message == "Unauthenticated.") {
							context.commit("setUser", null);
							window.location.href = "/#/";
							window.location.reload();
						}
						if (error?.response?.data?.error == "Invalid token.") {
							context.commit("setUser", null);
							window.location.href = "/#/";
							window.location.reload();
						}
						if (error?.response?.data?.error == "Invalid or expired token.") {
							context.commit("setUser", null);
							window.location.href = "/#/";
							window.location.reload();
						}
					});
			});
		},

		async error(context, description) {
			await createToast(
				{
					title: "Error",
					description: description || "The given data was invalid.",
				},
				{
					showIcon: true,
					hideProgressBar: true,
					type: "danger",
					position: "top-right",
				}
			);
		},

		async success(context, description) {
			await createToast(
				{
					title: "Success",
					description: description || "Data is successfuly subbmited.",
				},
				{
					showIcon: true,
					hideProgressBar: true,
					type: "success",
					position: "top-right",
				}
			);
		},

		async info(context, description) {
			await createToast(
				{
					title: "Info",
					description: description || "Not enoguh input data",
				},
				{
					showIcon: true,
					hideProgressBar: true,
					type: "info",
					position: "top-right",
				}
			);
		},
	},
});
